import * as actions from "./actions";
import produce from "immer";

const initialState = {
  value: null,
};

export const reducer = produce((state, action) => {
  switch (action.type) {
    case actions.SETHEADERINTEGRATION:
      state.value = action.payload.value;
      break;
    default:
      break;
  }
}, initialState);
